import React, {Component} from "react";
import FlexView from "react-flexview";
import M from "moment";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import * as R from "ramda";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import {defaultTableChange} from "../../../../modules/custom/customTable";
import {formGroup, tableConfig} from "../config";
import {ACTIVITY_TYPE, HttpStatus} from "../../../common/Constants";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import NotificationModifying from "./notificationModifying";
import {flattenFormGroupObject, mapToObjectDDL, removeNullFields} from "../../../common/mapper";
import {contructQueryParam, fetchDataAsync} from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";

class NotificationTab extends Component {
    actionButtons = [
        {
            name: "status",
            label: "Aksi",
            options: {
                customBodyRender: (val, {rowIndex}) => {
                    return (
                        this.props.tab === "customer"
                            ? <FlexView vAlignContent="center" style={{gap: 30}}>
                                <SimpleButton
                                    category="action_button"
                                    style={{backgroundColor: "transparent"}}
                                    icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-eye"/>}
                                    onClick={() => this.handleModifyingVisibility(ACTIVITY_TYPE.VIEW, rowIndex)}
                                />
                                {!(val === "SEND" || val === "DELETED") && (
                                    <SimpleButton
                                        category="action_button"
                                        style={{backgroundColor: "transparent"}}
                                        icon={<i style={{fontSize: 20, color: "red"}}
                                                 className="fa fa-lw fa-pencil-alt"/>}
                                        onClick={() => this.handleModifyingVisibility(ACTIVITY_TYPE.UPDATE, rowIndex)}
                                    />
                                )}
                                {!(val === "SEND" || val === "DELETED") && (
                                    <SimpleButton
                                        category="action_button"
                                        style={{backgroundColor: "transparent"}}
                                        icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-trash"/>}
                                        onClick={() => this.handleShowAlert(rowIndex)}
                                    />
                                )}
                            </FlexView>
                            : <FlexView vAlignContent="center" style={{gap: 30}}>
                                <SimpleButton
                                    category="action_button"
                                    style={{backgroundColor: "transparent"}}
                                    icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-eye"/>}
                                    onClick={() => this.handleModifyingVisibility(ACTIVITY_TYPE.VIEW, rowIndex)}
                                />
                            </FlexView>
                    )
                },
            }
        }
    ];

    constructor(props) {
        super(props);
        this.state = {
            toSend: null,
            loading: false,
            modifyingVisible: false,
            confirmVisible: false,
            activityType: null,
            selectedData: null,
            deleteId: "",
            dataTable: [],
            tableConfig: [],
            search: {
                startDateTanggalDikirim: null,
                endDateTanggalDikirim: null,
            },
            dataCustomer: [],
            submittedFilter: {},
            pagination: {
                page: 1,
                limit: 5,
                totalData: 1,
            },
        };
    };

    componentDidMount = async () => {
        this.setState((prevValue) => ({
            ...prevValue,
            tableConfig: [
                ...this.props.tab === "customer" ? tableConfig.customer : tableConfig.system,
                ...this.actionButtons,
            ],
        }));
        await this.fetchData();
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchData = async () => {
        this.handleTriggerLoading();
        try {
            let res = await fetchDataAsync({
                asyncFn: R.equals(this.props.tab, "customer")
                    ? Api.create("NAGAMAS_TRANSACTION").getDataNotificationTabCustomer
                    : R.equals(this.props.tab, "system")
                        ? Api.create("NAGAMAS_TRANSACTION").getDataNotificationTabSystem
                        : "",
                setError: this.props.setError,
                menuName: "Management Notification",
                args: {
                    ...this.state.search,
                    page: this.state.pagination.page,
                    limit: this.state.pagination.limit,
                },
            });
            if (res.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataTable: res.data.data,
                    pagination: {
                        ...prevValue.pagination,
                        totalData: res.data.totalData,
                    }
                }));
            }
        } catch (e) {
            console.log("error", e);
        }
        this.handleTriggerLoading();
    };

    handleChangePage = async (tableState) => {
        let limit = tableState.rowsPerPage;
        let page = tableState.page + 1;
        await this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: page,
                limit: limit,
            },
        }));
        await this.fetchData();
    };

    handleChangeRowsPerPage = async (tableState) => {
        let limit = tableState.rowsPerPage;
        await this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                totalData: 1,
                page: 1,
                limit: limit,
            }
        }));
        await this.fetchData();
    };

    handlePeriodeChange = (name, value) => {
        if (R.equals(name, "endDateTanggalDikirim") && M(value, "DD-MM-YYYY").isBefore(M(this.state.search.startDateTanggalDikirim, "DD-MM-YYYY"))) {
            this.setState((prevValue) => ({
                ...prevValue,
                search: {
                    ...prevValue.search,
                    startDateTanggalDikirim: M(value).format("DD-MM-YYYY"),
                    endDateTanggalDikirim: M(value).format("DD-MM-YYYY"),
                },
            }));
            return;
        }

        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: M(value).format("DD-MM-YYYY"),
            },
        }));
    };

    handleShowAlert = (id) => {
        if (id >= 0) {
            const idNotifikasi = this.state.dataTable[id].idNotifikasi;
            this.setState((prevValue) => ({...prevValue, deleteId: idNotifikasi}));
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                deleteId: "",
            }));
        }
    };

    handleModifyingVisibility = async (at, id) => {
        this.handleTriggerLoading();
        if (id >= 0) {
            const idNotifikasi = this.state.dataTable[id].idNotifikasi;
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailNotification,
                setError: this.props.setError,
                menuName: "Management Notification",
                args: contructQueryParam({
                    idNotifikasi,
                    activityType: at,
                }),
            });
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                let {dataCustomer, ...rest} = res.data.data;
                this.setState((prevValue) => ({
                    ...prevValue,
                    modifyingVisible: !prevValue.modifyingVisible,
                    selectedData: {
                        ...rest,
                        kategoriNotifikasi: mapToObjectDDL(rest.kategoriNotifikasi.value, rest.kategoriNotifikasi.key),
                        dataCustomerRaw: dataCustomer,
                        dataCustomer: at === ACTIVITY_TYPE.VIEW ? dataCustomer.filter(item => item.checked === true) : dataCustomer,
                    },
                    activityType: at,
                }));
            }
        } else {
            if (at === ACTIVITY_TYPE.CREATE) {
                let res2 = await fetchDataAsync({
                    asyncFn: Api.create("NAGAMAS_TRANSACTION").getCustomerNonUUID,
                    menuName: "Management Notification",
                    setError: this.props.setError
                });
                if (res2.ok && res2.data.status === HttpStatus.SUCCESS) {
                    let dataCustomer = res2.data.data.map(item => {
                        return ({memberId: item.customerId, namaCustomer: item.nama, checked: false});
                    });
                    this.setState((prevValue) => ({
                        ...prevValue,
                        selectedData: {dataCustomer: dataCustomer, dataCustomerRaw: dataCustomer},
                        modifyingVisible: !prevValue.modifyingVisible,
                        activityType: at,
                    }));
                }
            } else {
                this.setState((prevValue) => ({
                    ...prevValue,
                    selectedData: null,
                    modifyingVisible: !prevValue.modifyingVisible,
                    activityType: at,
                }));
            }
        }
        this.handleTriggerLoading();
    };

    handleDeleteNotification = async () => {
        this.handleTriggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").deleteNotification,
            menuName: "Management Notification",
            setError: this.props.setError,
            args: this.state.deleteId,
        });
        if (res.ok) {
            this.fetchData();
        }
        this.handleShowAlert();
        this.handleTriggerLoading();
    };

    handleSubmitModifying = async (controls, type, selectedCustomer) => {
        let {dataCustomer, ...request} = {
            ...flattenFormGroupObject(controls),
            kategoriNotifikasi: controls.kategoriNotifikasi.value.value,
            listMemberId: selectedCustomer
        };
        if (type === "save") {
            this.handleTriggerLoading();
            await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_TRANSACTION")
                    .submitNotificationCustomer,
                menuName: "Management Notification",
                setError: this.props.setError,
                args: removeNullFields({...request, status: "DRAFT"}),
            });
            // this.handleRefreshPagination()
            this.setState((prevValue) => ({
                ...prevValue,
                modifyingVisible: !prevValue.modifyingVisible,
            }));
            await this.fetchData();
            this.handleTriggerLoading();
            return;
        }
        this.setState((prevValue) => ({
            ...prevValue,
            toSend: {...request, status: "SEND"},
        }));
        this.handleSendNotification(type);
    };

    handleSendNotification = async (type) => {
        if (type === "send") {
            this.setState((prevValue) => ({
                ...prevValue,
                confirmVisible: !prevValue.confirmVisible,
            }));
            return;
        } else if (type === "confirm") {
            this.handleTriggerLoading();
            await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_TRANSACTION").submitNotificationCustomer,
                menuName: "Management Notification",
                setError: this.props.setError,
                args: removeNullFields({
                    ...this.state.toSend,
                    tanggalNotifikasiDikirim: M(new Date()).format("DD-MM-YYYY"),
                }),
            });
            this.setState((prevValue) => ({
                ...prevValue,
                modifyingVisible: !prevValue.modifyingVisible,
            }));
            // this.handleRefreshPagination()
            await this.fetchData();
            this.handleTriggerLoading();
        }
        this.setState((prevValue) => ({
            ...prevValue,
            confirmVisible: !prevValue.confirmVisible,
            toSend: null,
        }));
    };

    handleRefreshPagination = (resetPage = false) => {
        this.setState((prevState) => ({
            ...prevState,
            pagination: {
                ...prevState.pagination,
                page: resetPage ? 1 : prevState.pagination.page,
            },
        }));
    };


    render() {
        return (
            <>
                <FlexView style={{justifyContent: "space-between"}}>
                    <FlexView vAlignContent="center" style={{gap: "10px"}}>
                        <p className="margin-bottom-20px">Periode: </p>
                        <SimpleDate
                            id="select_prospek_date_period_from"
                            name="tanggalAwal"
                            nextdate
                            date={this.state.search.startDateTanggalDikirim}
                            maxDate={this.state.search.endDateTanggalDikirim}
                            onChange={(value) => this.handlePeriodeChange("startDateTanggalDikirim", value)}
                        />
                        <span className="margin-bottom-20px">s/d</span>
                        <SimpleDate
                            id="select_prospek_date_period_to"
                            name="endMutation"
                            backdate
                            date={this.state.search.endDateTanggalDikirim}
                            minDate={this.state.search.startDateTanggalDikirim}
                            onChange={(value) => this.handlePeriodeChange("endDateTanggalDikirim", value)}
                        />
                        <SimpleButton className="margin-bottom-20px" onClick={() => this.fetchData(this.state.search)}>
                            Cari
                        </SimpleButton>
                    </FlexView>
                </FlexView>
                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.state.tableConfig}
                    toCount={this.state.pagination.totalData}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={defaultTableChange(this.handleChangePage, this.handleChangeRowsPerPage)}
                    footerAdditionalButtons={
                        <>
                            {this.props.tab === "customer" && (
                                <SimpleButton
                                    onClick={() => this.handleModifyingVisibility(ACTIVITY_TYPE.CREATE)}
                                    icon={<i className="fa fa-plus margin-right-10px"/>}
                                >Tambah</SimpleButton>
                            )}
                        </>
                    }
                />
                {this.state.modifyingVisible && (
                    <NotificationModifying
                        formGroup={formGroup}
                        tab={this.props.tab}
                        setError={this.props.setError}
                        visible={this.state.modifyingVisible}
                        onClickClose={this.handleModifyingVisibility}
                        initialValues={this.state.selectedData}
                        activityType={this.state.activityType}
                        onSubmit={this.handleSubmitModifying}
                        triggerLoading={this.handleTriggerLoading}
                    />
                )}
                {this.state.deleteId !== "" && (
                    <SimpleAlert
                        visible={this.state.deleteId !== ""}
                        onClickClose={() => this.handleShowAlert()}
                        content={
                            <div>
                                <p>Notifikasi akan di hapus, apakah anda yakin?</p>
                            </div>
                        }
                        additionalButtons={
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <SimpleButton secondary onClick={() => this.handleShowAlert()}>
                                    Batal
                                </SimpleButton>
                                <SimpleButton onClick={this.handleDeleteNotification}>Iya</SimpleButton>
                            </FlexView>
                        }/>
                )}
                {this.state.confirmVisible && (
                    <SimpleAlert
                        visible={this.state.confirmVisible}
                        onClickClose={() => this.handleSendNotification()}
                        content={
                            <div>
                                <p>Notifikasi akan di dikirim, apakah anda yakin?</p>
                            </div>
                        }
                        additionalButtons={
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <SimpleButton secondary onClick={() => this.handleSendNotification()}>
                                    Batal
                                </SimpleButton>
                                <SimpleButton onClick={() => this.handleSendNotification("confirm")}>Iya</SimpleButton>
                            </FlexView>
                        }/>
                )}
                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        );
    };
}

export default NotificationTab;